import * as Url from './url'
import {httpRequest} from '@/api/http-request'
import apiInterface from '@/api/interface'
let Oss = require('@/../static/js/oss-player/oss-player')

export function VideoPlayer(id, title, index) {
  this.id = id
  this.title = title
  this.index = index
  this.playProtocol = 0 // 播放类型,0-rtmp,1-hls,2-http-flv,3-ws-flv
  this.streamNodeId = 0
  this.streamNodeName = ''
  this.streamOpenMode = 0
  this.audioEnabled = false
  this.accessToken = ''
  this.streamServerIp = ''
  this.streamServerPort = 0
  this.aspectRatio = '4:3'
  this.stretching = 2 // 缩放方式，0-不缩放,1-添加边缩放,2-改变宽高比缩放到最大,3-剪切并缩放到最大
  this.sourceType = ''
  this.sourceUrl = ''
  this.active = false
  this.paused = false
  this.selected = false
  this.rawPlayer = null
  this.playerMediaSource = null
}

// 开始播放（包含请求）
VideoPlayer.prototype.startPlayWithRequest = function(streamNodeId, streamNodeName, streamOpenMode, audioEnabled, accessToken, playProtocol, streamServerIp, streamServerPort) {
  return new Promise((resolve) => {
    this.playProtocol = playProtocol
    this.streamNodeId = streamNodeId
    this.streamNodeName = streamNodeName
    this.streamOpenMode = streamOpenMode
    this.audioEnabled = audioEnabled
    this.accessToken = accessToken
    this.streamServerIp = streamServerIp
    this.streamServerPort = streamServerPort

    // 请求调阅实时视频
    let params = {
      nodeId: this.streamNodeId,
      streamOpenMode: this.streamOpenMode,
      audioEnabled: this.audioEnabled ? 1 : 0
    }
    var _this = this
    httpRequest(apiInterface.startVideo, params).then(res => {
      if (res.code === 200) {
        _this.active = true
        _this.paused = false

        // 构建源url
        _this._formatUrl()
        //
        _this.playerMediaSource = {}
        _this.playerMediaSource.videoId = _this.id
        _this.playerMediaSource.name = _this.streamNodeName
        _this.playerMediaSource.sourceType = _this.sourceType
        _this.playerMediaSource.source = _this.sourceUrl
        _this.playerMediaSource.audioEnabled = audioEnabled
        _this.playerMediaSource.autoPlay = true

        _this.rawPlayer = Oss.createPlayer(_this.playerMediaSource)
        _this.rawPlayer.play()
      }
      resolve(res.code)
    }).catch(() => {
      resolve(500)
    })
  })
}

// 开始播放
VideoPlayer.prototype.startPlay = function(streamNodeId, streamNodeName, streamOpenMode, audioEnabled, accessToken, playProtocol, streamServerIp, streamServerPort) {
  return new Promise((resolve) => {
    this.streamNodeId = streamNodeId
    this.streamNodeName = streamNodeName
    this.streamOpenMode = streamOpenMode
    this.audioEnabled = audioEnabled
    this.accessToken = accessToken
    this.playProtocol = playProtocol
    this.streamServerIp = streamServerIp
    this.streamServerPort = streamServerPort

    this.active = true
    this.paused = false

    // 构建源url
    this._formatUrl()
    //
    this.playerMediaSource = {}
    this.playerMediaSource.videoId = this.id
    this.playerMediaSource.name = this.streamNodeName
    this.playerMediaSource.sourceType = this.sourceType
    this.playerMediaSource.source = this.sourceUrl
    this.playerMediaSource.audioEnabled = audioEnabled
    this.playerMediaSource.autoPlay = true

    this.rawPlayer = Oss.createPlayer(this.playerMediaSource)
    this.rawPlayer.play()
    resolve(200)
  })
}

// 停止播放（包含请求）
VideoPlayer.prototype.stopPlayWithRequest = function() {
  return new Promise((resolve) => {
    if (!this.active || this.streamNodeId === 0) {
      resolve(500)
      return
    }

    // 请求停止调阅实时视频
    let params = {
      nodeId: this.streamNodeId,
      streamOpenMode: this.streamOpenMode
    }
    httpRequest(apiInterface.stopVideo, params).then(res => {
      if (res.code === 200) {
      }

      if (this.rawPlayer) {
        this.rawPlayer.stop()
        this.rawPlayer = null
      }

      this.playerMediaSource.autoPlay = false
      this.playerMediaSource.name = this.title
      this.playerMediaSource.videoId = 0
      this.playerMediaSource.source = ''

      this.active = false
      this.paused = false
      this.streamNodeId = 0
      this.streamNodeName = ''
      this.streamOpenMode = 0
      this.audioEnabled = false
      this.accessToken = ''
      resolve(res.code)
    }).catch(() => {
      resolve(500)
    })
  })
}

// 停止播放
VideoPlayer.prototype.stopPlay = function() {
  return new Promise((resolve) => {
    if (!this.active) {
      resolve(500)
      return
    }

    if (this.rawPlayer) {
      this.rawPlayer.stop()
      this.rawPlayer = null
    }

    this.playerMediaSource.autoPlay = false
    this.playerMediaSource.name = this.title
    this.playerMediaSource.videoId = 0
    this.playerMediaSource.source = ''

    this.active = false
    this.paused = false
    this.streamNodeId = 0
    this.streamNodeName = ''
    this.streamOpenMode = 0
    this.audioEnabled = false
    this.accessToken = ''
    resolve(200)
  })
}

// 暂停播放
VideoPlayer.prototype.pausePlay = function() {
  if (!this.active) {
    return
  }
  this.rawPlayer.pause()
  this.playerMediaSource.name = this.title

  this.active = false
  this.paused = true
}

// 恢复播放
VideoPlayer.prototype.resumePlay = function() {
  if (!this.active || !this.paused) {
    return
  }
  this.active = true
  this.paused = false

  // 构建源url
  this._formatUrl()
  //
  this.playerMediaSource.name = this.streamNodeName
  this.rawPlayer.start()
}

// 构建源url
VideoPlayer.prototype._formatUrl = function() {
  if (this.playProtocol === 0) { // rtmp
    this.sourceType = 'rtmp/mp4'
  } else if (this.playProtocol === 1) { // hls
    this.sourceType = 'application/x-mpegURL'
  } else if (this.playProtocol === 3) { // ws-flv
    this.sourceType = 'video/x-flv'
  }
  this.sourceUrl = formatPlayUrl(this.playProtocol, this.streamNodeId, this.streamOpenMode, this.audioEnabled, this.streamServerIp, this.streamServerPort, this.accessToken)

  return this.sourceUrl
}

// 构建播放url
export function formatPlayUrl(playProtocol, streamNodeid, streamOpenMode, audioEnabled, streamServerIp, streamServerPort, accessToken) {
  let isProduction = process.env.NODE_ENV === 'production'
  let hostAndPort = ''
  if (streamServerIp && streamServerPort > 0) { // 使用获取的流媒体服务信息
    hostAndPort = streamServerIp + ':' + streamServerPort
  } else { // ip从url获取，port从url获取或从配置指定
    let playPort = window && window.config ? window.config.playPort : 0
    if (playPort === 0) {
      hostAndPort = Url.getHttpHostAndPort()
    } else {
      hostAndPort = Url.getHttpHost() + ':' + playPort
    }
  }

  let videoUrl = ''
  if (playProtocol === 0) { // rtmp
    if (isProduction) {
      videoUrl = 'rtmp://' + hostAndPort + '/live/' + streamNodeid + '?streamOpenMode=' + streamOpenMode +
        '&audioEnabled=' + audioEnabled + '&accessToken=' + accessToken
    } else {
      videoUrl = 'rtmp://192.168.1.20:/live/' + streamNodeid + '?streamOpenMode=' + streamOpenMode +
        '&audioEnabled=' + audioEnabled + '&accessToken=' + accessToken
    }
  } else if (playProtocol === 1) { // hls
    if (isProduction) {
      videoUrl = Url.getProtocol() + '// ' + hostAndPort + '/live/' + streamNodeid + '/index.m3u8' + '?streamOpenMode=' + streamOpenMode +
        '&audioEnabled=' + audioEnabled + '?accessToken=' + accessToken
    } else {
      videoUrl = 'http://192.168.1.20:8090/live/' + streamNodeid + '/index.m3u8' + '?streamOpenMode=' + streamOpenMode +
        '&audioEnabled=' + audioEnabled + '?accessToken=' + accessToken
    }
  } else if (playProtocol === 2) { // http-flv
    if (isProduction) {
      videoUrl = Url.getProtocol() + '// ' + hostAndPort + '/httpflv/' + streamNodeid + '.flv?app=live&streamOpenMode=' + streamOpenMode +
        '&audioEnabled=' + audioEnabled + '&accessToken=' + accessToken
    } else {
      videoUrl = 'http://192.168.1.20:8090/httpflv/' + streamNodeid + '.flv?app=live&streamOpenMode=' + streamOpenMode +
        '&audioEnabled=' + audioEnabled + '&accessToken=' + accessToken
    }
  } else if (playProtocol === 3) { // ws-flv
    if (isProduction) {
      videoUrl = (Url.getProtocol().indexOf('https') !== -1 ? 'wss://' : 'ws://') + hostAndPort + '/wsflv/' + streamNodeid + '.flv?app=live&streamOpenMode=' + streamOpenMode +
        '&audioEnabled=' + audioEnabled + '&accessToken=' + accessToken
    } else {
      videoUrl = 'ws://139.196.140.157:8090/wsflv/' + streamNodeid + '.flv?app=live&streamOpenMode=' + streamOpenMode +
        '&audioEnabled=' + audioEnabled + '&accessToken=' + accessToken
      // videoUrl = 'ws://' + hostAndPort + '/wsflv/' + streamNodeid + '.flv?app=live&streamOpenMode=' + streamOpenMode +
      // '&audioEnabled=' + audioEnabled + '&accessToken=' + this.accessToken
    }
  }

  console.log(videoUrl)
  return videoUrl
}



// WEBPACK FOOTER //
// ./src/utils/video-player.js